import React, { memo, useEffect } from "react"; //  path to password Reset component
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { loginWithSessionToken } from "../../utils/signup";
import { setToken } from "../../utils/tokenStorage";
import { useDispatch } from "react-redux";
import {
  setUserInformation,
  setUserPermissions,
  setUserRole,
} from "../../store/userRole";
import { useAppContext } from "../../AppContext";
import { fetchCategories } from "../../store/categoriesSlice";
import { clearSubscription } from "../../store/subscriptionSlice";
import { toast } from "react-toastify";

const VerifyStudentSession = () => {
  const { token } = useParams();
  const storeDispatch = useDispatch();
  const { dispatch } = useAppContext();
  const navigate = useNavigate();

  const verifySessionToken = async () => {
    try {
      const payload = {
        tokenForLogin: token,
      };

      const loginResponse = await loginWithSessionToken(payload);
      if (loginResponse.ok && loginResponse.data.token) {
        // Handle successful login
        setToken(loginResponse.data.token);
        const roleOfUser = loginResponse.data.user.roleName;
        storeDispatch(setUserRole(roleOfUser));
        storeDispatch(setUserInformation(loginResponse.data.user));
        storeDispatch(setUserPermissions(loginResponse.data.user.permissions));
        dispatch({ type: "SET_AUTH_STATUS", payload: true });
        dispatch(fetchCategories());
        storeDispatch(clearSubscription());

        toast.success("Login successful!", {
          onClose: async () => {
            // Role-based redirect after successful verification
            const adminRoles = [
              "Admin",
              "SuperAdmin",
              "Root",
              "Teacher",
              "Watcher",
            ];
            const isAdminUser =
              adminRoles.includes(roleOfUser) || roleOfUser !== "Student";

            if (isAdminUser) {
              navigate("/myClassrooms", { replace: true });
            } else {
              navigate("/student/myClassrooms", { replace: true });
            }
          },
        });
      } else {
        toast.error(loginResponse.error || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  useEffect(() => {
    verifySessionToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Loader />;
};

export default memo(VerifyStudentSession);
